import React, { useEffect, useRef, useState, useCallback } from 'react';
import ScriptDialog from 'app/fuse-layouts/shared-components/ScriptDialog';
import OwnerSelectionCard from 'app/shared-components/OwnerSelectionCard';
import { GlobalProvisionScriptsPreview, ClusterApplicationsSection } from '../components';
import {
    Button, DialogContent, DialogTitle, Divider, Fab, FormControl,
    FormControlLabel, Icon, IconButton, InputAdornment, InputBase, Menu, MenuItem,
    Paper, Popover, Radio, RadioGroup, Table, TableBody, TableCell, TableHead,
    TableRow, TextField, Typography, Checkbox,
    // new imports for card layout
    Card, CardHeader, CardContent, Box, Tooltip, Chip
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import axios from 'axios';
import clsx from 'clsx';
import Formsy from 'formsy-react';
import _ from '@lodash';

import { useForm } from '@fuse/hooks';
import { CheckboxFormsy, FuseAnimate, SelectFormsy, TextFieldFormsy } from '@fuse';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../store/actions';
import * as ActionsDialog from 'app/store/actions';
import * as MarketActions from 'app/main/marketplace/store/actions';
import * as StackActions from 'app/main/stacks/store/actions/stacks.actions.js';
import { ipValid, setinstancesVol, validationInputUlt, validationMessUlt } from '../../util/InputValidate';
import { API_BASE_URL } from '@config';
import useStyles from 'app/cluster-styles/useStyles';
import { getClusterSettings } from 'app/main/settings/store/actions';
import { CLUSTER_STATES, DisabledFormWrapper } from 'app/main/util/clusterUtils';
import { RESOURCE_MANAGER, IMAGE_TYPE, IMAGE_MODE } from "../../util/enums";
import { useInstanceAvailability } from '../hooks/useInstanceAvailability';
import { ZoneAvailabilityIndicator } from '../components/ZoneAvailabilityComponents';

// add this below your imports
const cardHeaderStyle = {
  backgroundColor: '#f7f9fc',
  paddingBottom: '8px',
  minHeight: '20px'
};
const sectionTitleStyle = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#0f2147'
};
const cardStyle = {
    marginBottom: '24px',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
    borderRadius: '8px',
    overflow: 'visible'
};
// Add inputGroupStyle to match AWS
const inputGroupStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    marginBottom: '16px',
    alignItems: 'flex-start'
};
const tooltipIconStyle = {
    marginLeft: '8px',
    color: '#757575',
    fontSize: '18px'
};
// Add these new styles for column layout
const columnContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    width: '100%'
};
const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0, // This prevents flex items from overflowing
};

const AzureCluster = props => {
    const dispatch = useDispatch();
    const classes = useStyles(props);
    const formRef = useRef(null)
    const pkgRef = useRef(null);

    // Select various states from the Redux store
    const clusterSettings = useSelector(({ settings }) => settings.settings.clusterSettings);
	const cluster = useSelector(({ clusters }) => clusters.cluster.cluster);
    const clustersArr = useSelector(({ clusters }) => clusters.cluster.list);
    const error = useSelector(({ clusters }) => clusters.cluster.error);
    const providers = useSelector(({ providers }) => providers.providers.list);
    const loading = useSelector(({ fuse }) => fuse.settings.loading);
    const credentials = useSelector(({ credentials }) => credentials.credential.list);
    const supportedOSs = useSelector(({ clusters }) => clusters.cluster.os_types);
    const marketplaceData = useSelector(({ marketStack }) => marketStack.marketStack.list);
    const selectedMarketStack = useSelector(({ marketStack }) => marketStack.marketStack.stack);
    const globalProvisionPreview = useSelector(({ globalProvision }) => globalProvision?.preview);
    const stacks = useSelector(({ stacks }) => stacks.stack.list);
    const currentUser = useSelector(({ auth }) => auth.user);
    const users = useSelector(({ auth }) => auth.user.users) || [];

    // Define local state variables
    const [isFormValid, setIsFormValid] = useState(false);
    const [selectedOwner, setSelectedOwner] = useState('');
    const [excludedGlobalScripts, setExcludedGlobalScripts] = useState([]);
    // Cluster applications state (Feature: cluster-apps)
    const [clusterApplications, setClusterApplications] = useState([]);
    const [enableNodeInternetAccess, setEnableNodeInternetAccess] = useState(false);
    const [enableCapacityReservation, setEnableCapacityReservation] = useState(false);
    const [capacityReservationAutoExpire, setCapacityReservationAutoExpire] = useState(true);
    const [capacityReservationExpireHours, setCapacityReservationExpireHours] = useState(1);
    const [zones, setZones] = useState([]);
    const [regions, setRegions] = useState([]);
    const [nodeInstanceSizes, setNodeInstanceSizes] = useState(null);
    const [serverInstanceSizes, setServerInstanceSizes] = useState([]);
    const [filteredCredentials, setFilteredCredentials] = useState([]);
    const [deletedPkgs, setDeletedPkgs] = useState([]);
    const [cost, setCost] = useState(0);
    const [popovertarget, setPopovertarget] = useState(null);
    const [timeoutid, setTimeoutid] = useState(null);
    const [providerVolsize, setProviderVolsize] = useState({ min: 10, max: 1000 });
    const [clusterNames, setClusterNames] = useState(null)
    const [showStaticIP, setShowStaticIP] = useState(null);

    //this is for the prefix form
    const groupNodePrefixRefs = useRef([]);
    const textFieldRef = useRef(null);
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [groupNodeInputValues, setGroupNodeInputValues] = useState({});
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [advanced, setAdvanced] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [prefixError, setPrefixError] = useState("");
    const [nodePrefixErrors, setNodePrefixErrors] = useState([]);

    //quotas
    const [usedIntances, setUsedIntances] = useState(0);
    const [usedNetwork, setUsedNetwork] = useState(0);
    const [usedCpus, setUsedCpus] = useState(0);
    const [limitIntances, setLimitIntances] = useState(9999999);
    const [limitNetwork, setLimitNetwork] = useState(9999999);
    const [limitCpus, setLimitCpus] = useState(9999999);

    // Use custom hook for form state and handling changes
    const { form, handleChange, setForm } = useForm(props.oldForm || null);
    const [selectedShapes, setSelectedShapes] = useState([]);

    // Compute node instance types for availability checking
    const computeNodeInstanceTypes = React.useMemo(() => {
        if (!form || !form.data || !form.data.node || !form.data.node.group) {
            return [];
        }
        return form.data.node.group
            .map(function(node) { return node.instance_id; })
            .filter(Boolean);
    }, [form]);

    const {
        zoneAvailability,
        isZoneAvailable,
        getMissingInstances,
        isLoading: isAvailabilityLoading,
        error: availabilityError,
        unableToVerify
    } = useInstanceAvailability({
        provider: 'azure',
        credentialId: form && form.credential_id,
        region: form && form.data && form.data.network && form.data.network.region_id,
        headNodeInstance: form && form.data && form.data.server && form.data.server.instance_id,
        computeNodeInstances: computeNodeInstanceTypes,
        enabled: Boolean(form && form.credential_id && form.data && form.data.network && form.data.network.region_id)
    });

    // Azure region-level availability (checks if available in ANY zone)
    const azureRegionAvailable = React.useMemo(() => {
        if (unableToVerify) return null;
        if (!zoneAvailability || Object.keys(zoneAvailability).length === 0) return null;
        return Object.values(zoneAvailability).some(function(z) { return z.available; });
    }, [zoneAvailability, unableToVerify]);

    // Azure missing instances (aggregate across all zones)
    const azureMissingInstances = React.useMemo(() => {
        if (!zoneAvailability || Object.keys(zoneAvailability).length === 0) return [];
        return Object.values(zoneAvailability).reduce(function(acc, z) {
            z.missingInstances.forEach(function(inst) {
                if (acc.indexOf(inst) === -1) acc.push(inst);
            });
            return acc;
        }, []);
    }, [zoneAvailability]);

    // Image type state variables
    const [serverImageType, setServerImageType] = useState(IMAGE_TYPE.HEIDI_STACK);
    const [nodeImageTypes, setNodeImageTypes] = useState({});
    const [imageMode, setImageMode] = useState(IMAGE_MODE.MULTI_IMAGE);

    //General Marketplace information:
    const market_id_value = selectedMarketStack?.id
    const marketId = form?.info?.market_id ?? market_id_value
    const isMarketStack = Boolean(selectedMarketStack)
    // Fix: Find the market stack in the array by its ID instead of using direct indexing
    const currentMarketStack = marketplaceData?.find(item => item.id === marketId) || selectedMarketStack

    // Add null checks and fallbacks for all marketplace configuration properties
    const hasMarketplaceConfig = Boolean(currentMarketStack?.config)
    const marketplace_head_image_id = hasMarketplaceConfig ? currentMarketStack.config.marketplace_head_image_id : null
    const marketplace_compute_image_id = hasMarketplaceConfig ? (currentMarketStack.config.marketplace_compute_image_id || currentMarketStack.config.marketplace_head_image_id) : null
    const marketplaceManager = hasMarketplaceConfig ? currentMarketStack.config.resource_manager : null

    // For Azure-specific marketplace configuration
    const marketplace_publisher = hasMarketplaceConfig ? currentMarketStack.config.publisher : null
    const marketplace_offer = hasMarketplaceConfig ? currentMarketStack.config.offer : null
    const marketplace_sku = hasMarketplaceConfig ? currentMarketStack.config.sku : null
    const marketplace_image_version = hasMarketplaceConfig ? currentMarketStack.config.marketplace_image_version : null
    const marketplace_allowed_regions = hasMarketplaceConfig && currentMarketStack.config.allowed_regions ? currentMarketStack.config.allowed_regions : []

    //Marketplace header information
    const marketName = currentMarketStack?.name
    const marketVersion = currentMarketStack?.version
    const title = currentMarketStack ? (marketName + ' ' + marketVersion) : form?.name || 'New Cluster'
    const imageSrc = currentMarketStack?.logo
        ? `assets/images/logos/${currentMarketStack?.logo}`
        : `assets/images/providers/azure.png`;

    //Marketplace form information
    const marketplaceOSTypes = currentMarketStack?.config?.os_types;
    const marketplaceInstanceIds = currentMarketStack?.config?.instance_type;
    const marketplaceComputeIds = currentMarketStack?.config?.computeNodeSize;
    const marketplaceRegionIds = currentMarketStack?.config?.allowed_regions;

    // Marketplace app profile flags (data-driven behavior)
    const marketplaceSkipSubscription = hasMarketplaceConfig && currentMarketStack.config.skip_subscription === true;
    const marketplaceHideProvisionScript = hasMarketplaceConfig && currentMarketStack.config.hide_provision_script === true;
    const marketplaceAllowImageSelection = hasMarketplaceConfig && currentMarketStack.config.allow_image_selection === true;
    const marketplaceDisableGlobalScripts = hasMarketplaceConfig && currentMarketStack.config.disable_global_scripts === true;
    const [isVncTokenAuthentication, setIsVncTokenAuthentication] = useState(false);
    const [isVncRemoteClient, setIsVncRemoteClient] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [isScriptOpen, setScriptOpen] = useState(false);

    const marketplace_image_reference = {
        publisher: currentMarketStack?.config?.publisher || 'paratools-inc',
        offer: currentMarketStack?.config?.offer || 'pt-pro-4-e4s-msa-cyclecloud-amd64',
        sku: currentMarketStack?.config?.sku || 'paratools-pro-cyclecloud-amd64',
        marketplace_image_version: currentMarketStack?.config?.marketplace_image_version || 'latest',
        requires_plan: currentMarketStack?.config?.requires_plan || false
    };
	useEffect(() => {
		if(props.type === 'edit' && form && form.info && form.info.state != CLUSTER_STATES.DESTROYED) {
			setDisableInputs(true);
		}
	}, [props, form])

    // Separate state for script management - only disable upload/delete, not view
    const [disableScriptModification, setDisableScriptModification] = useState(false);
    
    useEffect(() => {
        if(props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED) {
            setDisableScriptModification(true);
        }
    }, [props, form])

    // Load excluded global scripts when editing
    useEffect(() => {
        if (props.type === 'edit' && form) {
            // Check both locations - data.excludedGlobalScripts and root level excludedGlobalScripts
            const excluded = form.data?.excludedGlobalScripts || form.excludedGlobalScripts;
            if (excluded && excluded.length > 0) {
                setExcludedGlobalScripts(excluded);
            }
        }
    }, [props.type, form?.data?.excludedGlobalScripts, form?.excludedGlobalScripts]);

    // Auto-exclude ALL global provision scripts when marketplace config has disable_global_scripts
    useEffect(() => {
        if (marketplaceDisableGlobalScripts && globalProvisionPreview?.configs?.length > 0) {
            const allScriptIds = [];
            globalProvisionPreview.configs.forEach(function(config) {
                if (config.scripts) {
                    config.scripts.forEach(function(script) {
                        allScriptIds.push(config._id + '-' + script._id);
                    });
                }
            });
            if (allScriptIds.length > 0) {
                setExcludedGlobalScripts(allScriptIds);
            }
        }
    }, [marketplaceDisableGlobalScripts, globalProvisionPreview?.configs]);

    // Load cluster applications when editing or from marketplace pre-populated data
    useEffect(() => {
        if (form) {
            const apps = form.applications;
            if (apps && apps.length > 0) {
                setClusterApplications(apps);
            }
        }
    }, [props.type, form?.applications]);

    useEffect(() => {
        if (
            isMarketStack &&
            marketplaceManager &&
            form?.data &&
            form.data.manager !== marketplaceManager
        ) {
            setForm(prevForm => {
                if (!prevForm || !prevForm.data) return prevForm;
                return {
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        manager: marketplaceManager
                    }
                };
            });
        }
    }, [isMarketStack, marketplaceManager, form?.data?.manager, setForm, form]);    
        

    useEffect(() => {
        dispatch(StackActions.getStacks());
		dispatch(getClusterSettings());
    }, [dispatch]);
    useEffect(() => {
        dispatch(MarketActions.getMarketplaceStacks(marketplaceData))
    }, [dispatch, marketplaceData])

    useEffect(() => {
        const setVncValues = () => {
            if (form && form.info) {
                setIsVncTokenAuthentication(form.info.vncTokenAuthentication !== undefined ? form.info.vncTokenAuthentication : clusterSettings?.vncTokenAuthentication);
                setIsVncRemoteClient(form.info.vncRemoteClient !== undefined ? form.info.vncRemoteClient : clusterSettings?.vncRemoteClient);
            } else if (clusterSettings) {
                setIsVncTokenAuthentication(clusterSettings.vncTokenAuthentication);
                setIsVncRemoteClient(clusterSettings.vncRemoteClient);
            }
        };

        setVncValues();
    }, [form, clusterSettings]);

    // Set fast capacity validation default for new clusters
    useEffect(() => {
        if (props.type === 'new' && clusterSettings?.fastCapacityValidationDefault !== undefined) {
            setEnableCapacityReservation(clusterSettings.fastCapacityValidationDefault);
        }
    }, [props.type, clusterSettings]);

    useEffect(() => {
        if (props.type === 'new') {
            selectedMarketStack ?
                dispatch(Actions.newMarketCluster(selectedMarketStack)) :
                dispatch(Actions.newCluster());
        }
    }, [props.type, selectedMarketStack, dispatch]);
    useEffect(() => {
        const names = clustersArr.map(cluster => cluster.name);
        setClusterNames(names);
    }, [clustersArr, setClusterNames]);

    useEffect(() => {
        if (form?.data.node.group) {
            form.data.node.group.forEach(node => setSelectedShapes(prevSelectedShapes => [...prevSelectedShapes, node.instance_id]));
        }
    }, [form]);


    const setClusterInfo = (e) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, moab: { ...form.data.moab, [e.target.name]: e.target.value } }));
    }
    //this is to check if there is a static ip provided and updates the state if true.
    useEffect(() => {
        const isStaticIPProvided = form?.data?.network?.private_static_ip;
        setShowStaticIP(isStaticIPProvided !== null ? true : false);
    }, [setShowStaticIP, form]);

    //this is to check if there is a static ip provided and updates the state if true.
    useEffect(() => {
        const isStaticIPProvided = form?.data?.network?.private_static_ip;
        setShowStaticIP(isStaticIPProvided !== null ? true : false);
    }, [setShowStaticIP, form?.data?.network.private_static_ip]);

    useEffect(() => {
        if (form && form.data.network.region_id) {
            let costNodesTotal = 0;
            let costNode = 0;
            const sps = providers.filter(p => p.id === "azure");
            
            // Safety check: ensure Azure provider and instanceSizes exist
            if (!sps[0] || !sps[0].instanceSizes) {
                return;
            }
            
            const headNode = sps[0].instanceSizes.filter(r => r.instance_id === form.data.server.instance_id);
            const costHeadNode = headNode[0]?.cost?.cost_region[form.data.network.region_id];

            form.data.node.group.map(val => {
                const node = sps[0].instanceSizes.filter(r => r.instance_id === val.instance_id);
                const costNodes = node[0]?.cost?.cost_region[form.data.network.region_id];
                if (costNodes) {
                    costNode = costNodes * val.count;
                    costNodesTotal = costNodesTotal + costNode;
                }
                return 0;
            });
            setCost(costNodesTotal + costHeadNode);
        }
    }, [form, providers]);

    useEffect(() => {
        const err = error || props.error;
        if (err && err.type === 'form') {
            const name = { name: err.message };
            formRef.current &&
                formRef.current.updateInputsWithError({
                    ...name
                });
            disableButton();
        }
    }, [error, props.error]);

    useEffect(() => {
        if ((cluster && !form) || (cluster && form && cluster.id !== form.id)) {
            // Ensure the provision object with script field is initialized
            const clusterWithProvision = {
                ...cluster,
                data: {
                    ...cluster.data,
                    provision: {
                        ...cluster.data.provision || {},
                        script: cluster.data?.provision?.script || ''
                    },
                    network: {
                        ...cluster.data.network || {},
                        enable_node_internet_access: cluster.data.network?.enable_node_internet_access ?? false,
                        enable_capacity_reservation: cluster.data.network?.enable_capacity_reservation ?? false,
                        capacity_reservation_auto_expire: cluster.data.network?.capacity_reservation_auto_expire ?? true,
                        capacity_reservation_expire_hours: cluster.data.network?.capacity_reservation_expire_hours ?? 1
                    }
                }
            };
            setForm(clusterWithProvision);
            setEnableNodeInternetAccess(cluster.data.network?.enable_node_internet_access ?? false);
            setEnableCapacityReservation(cluster.data.network?.enable_capacity_reservation ?? false);
            setCapacityReservationAutoExpire(cluster.data.network?.capacity_reservation_auto_expire ?? true);
            setCapacityReservationExpireHours(cluster.data.network?.capacity_reservation_expire_hours ?? 1);
        }
    }, [form, cluster, setForm]);

    // Initialize selectedOwner when editing existing cluster
    useEffect(() => {
        if (props.type === 'edit' && form?.user && form.user.length > 0) {
            setSelectedOwner(form.user[0]);
        }
    }, [props.type, form?.user]);

    useEffect(() => {
        if (form && form.data.network.region_id) {
            providers.map(
                p =>
                    p.id === "azure" &&
                    p.regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones))
            );
        }
    }, [providers, form]);
    //Set instance sizes and node sizes here
    useEffect(() => {
        if (
            providers &&
            form &&
            (!nodeInstanceSizes || !serverInstanceSizes || !filteredCredentials || !regions || !zones)
        ) {
            const P = providers.find(provider => provider.id === "azure");
            
            // Safety check: ensure provider data exists
            if (!P || !P.instanceSizes || !P.regions) {
                console.warn('Azure provider data not fully loaded');
                return;
            }
            
            const InstSizes = P.instanceSizes;
            const Regions = P.regions;
            if (props.type !== 'new') {
                if (InstSizes.filter(s => s.instance_id === form.data.server.instance_id).length === 0) {
                    InstSizes.push({ instance_id: form.data.server.instance_id, name: form.data.server.instance_id, cores: 0 });
                }
                if (Regions.filter(r => r.region_id === form.data.network.region_id).length === 0) {
                    Regions.push({
                        region_id: form.data.network.region_id,
                        name: form.data.network.region_id,
                        zones: [form.data.network.zone_id]
                    });
                }
                for (const gs of form.data.node.group) {
                    let contains = false;
                    for (const s of InstSizes) {
                        if (s.instance_id === gs.instance_id) {
                            contains = true;
                        }
                    }
                    if (!contains) {
                        InstSizes.push({ instance_id: gs.instance_id, name: gs.instance_id, cores: 0 });
                    }
                }
            }
            const C = credentials.filter(cred => cred.provider === "azure");
            setNodeInstanceSizes(InstSizes);
            setServerInstanceSizes(InstSizes);
            setFilteredCredentials(C);
            setRegions(Regions);
            if (form.data.network.region_id) {
                Regions.map(r => r.zones && r.region_id === form.data.network.region_id && setZones(r.zones));
            }
        }
    }, [
        providers,
        props,
        form,
        credentials,
        nodeInstanceSizes,
        serverInstanceSizes,
        filteredCredentials,
        regions,
        zones
    ]);
    //prefix:
    useEffect(() => {
        setInputValue(form?.info?.prefix);
    }, [form]);

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    //group prefix:
    const handleGroupNodeMenuOpen = (index) => {
        setActiveMenuIndex(index);
    };

    const handleGroupNodeMenuItemClick = (index, selectedPrefix) => {
        setGroupNodeInputValues(prevValues => ({
            ...prevValues,
            [index]: selectedPrefix
        }));
        setNodePrefix(index, selectedPrefix);

        setActiveMenuIndex(null);
    };

    useEffect(() => {
        // Function to set the initial values for the node group and server instance
        const setInitialValues = () => {
            let initialNodeInstanceId = nodeInstanceSizes[0].instance_id;
            let initialServerInstanceId = serverInstanceSizes[0].instance_id;

            if (currentMarketStack) {
                initialNodeInstanceId = currentMarketStack.config?.computeNodeSize?.[0] ?? initialNodeInstanceId;
                initialServerInstanceId = currentMarketStack.config?.instance_type?.[0] ?? initialServerInstanceId;
            }
            form.data.node.group.forEach(groupItem => {
                if (!groupItem.instance_id) {
                    groupItem.instance_id = initialNodeInstanceId
                }
            })
            if (!form.data.server.instance_id) form.data.server.instance_id = initialServerInstanceId
            return { ...form }
        };
        if (form && form.data.node.group.length === 1 && !form.data.node.group[0].instance_id && nodeInstanceSizes) {
            setForm(setInitialValues())
        }
    }, [form, currentMarketStack, nodeInstanceSizes, serverInstanceSizes, setForm]);

    const setNodeObj = useCallback(({ name, value }) => {
        setForm(prevForm => {
            return {
                ...prevForm,
                data: {
                    ...prevForm.data,
                    node: {
                        ...prevForm.data.node,
                        [name]: value
                    }
                }
            };
        });
    }, [setForm]);

    useEffect(() => {
        if (form && form.data.server.disk_type !== form.data.node.disk_type) {
            setNodeObj({ name: 'disk_type', value: form.data.server.disk_type });
        }
    }, [form, setNodeObj]);

    // Auto-enable proximity placement groups for HPC/GPU instance types
    useEffect(() => {
        if (form && shouldEnableProximityPlacement(form) && !form.data.network.use_proximity_placement) {
            setForm(prevForm => ({
                ...prevForm,
                data: {
                    ...prevForm.data,
                    network: {
                        ...prevForm.data.network,
                        use_proximity_placement: true
                    }
                }
            }));
        }
    }, [form?.data?.server?.instance_id, form?.data?.node?.group]);

    useEffect(() => {
        setProviderVolsize(setinstancesVol("azure", isMarketStack)); //set Volume limit depending on provider
        dispatch(Actions.provider_os_types("azure"))
    }, [dispatch, isMarketStack]);

    // Auto-select OS type when marketplace app restricts supported OS types
    useEffect(() => {
        if (marketplaceOSTypes && supportedOSs && supportedOSs.length > 0 && form) {
            const allowedOSs = supportedOSs.filter(os => marketplaceOSTypes.includes(os));
            if (allowedOSs.length > 0 && !allowedOSs.includes(form.info['os-type'])) {
                setInfoObj({ name: 'os-type', value: allowedOSs[0] });
            }
        }
    }, [marketplaceOSTypes, supportedOSs]);

    useEffect(() => {
        if (form && form.data.node.group.length === 1 && !form.data.node.group[0].instance_id && nodeInstanceSizes) {
            const group = form.data.node.group;
            group[0].instance_id = nodeInstanceSizes[0].instance_id;
            group[0].count = props.job ? props.job.data.nodes : '0';
            setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...group] } }));
        }
        if (form && !form.data.server.instance_id && serverInstanceSizes.length > 0) {
            setForm(
                _.set({ ...form }, 'data', {
                    ...form.data,
                    server: { ...form.data.server, instance_id: serverInstanceSizes[0].instance_id }
                })
            );
        }
    }, [form, serverInstanceSizes, props, nodeInstanceSizes, setForm]);

    useEffect(() => {
        if (form?.data.network.region_id) {
            const sps = providers.filter(p => p.id === "azure");
            
            // Safety check: ensure Azure provider and required properties exist
            if (!sps[0] || !sps[0].regions || !sps[0].instanceSizes) {
                return;
            }
            
            const region = sps[0].regions.filter(r => r.region_id === form.data.network.region_id);
            const zone = region[0]?.zones?.filter(
                r => r.zone_id === form.data.network.availability_domain || r.zone_id === form.data.network.zone_id
            );

            const clustersInUse = clustersArr.filter(c => c.info.state !== 'down' && c.provider === "azure");
            let intances = clustersInUse.length;
            let network = clustersInUse.length;
            let cpus = 0;

            clustersInUse.forEach(c => {
                const fp = providers.filter(p => p.id === c.provider);
                if (!fp[0] || !fp[0].instanceSizes) return;
                //nodes used
                c.data.node.group.forEach(i => {
                    intances = parseInt(intances) + parseInt(i.count);
                    const ccores = fp[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                    cpus = cpus + parseInt(ccores[0]?.cores || 0) * i.count;
                });
                //server used
                const scores = fp[0].instanceSizes.filter(co => co.instance_id === c.data.server.instance_id);
                cpus = cpus + parseInt(scores[0]?.cores || 0);
            });

            //server edict
            const ecores = sps[0].instanceSizes.filter(co => co.instance_id === form.data.server.instance_id);
            network++;
            intances++;
            cpus = cpus + parseInt(ecores[0]?.cores || 0);

            form.data.node.group.forEach(i => {
                intances = parseInt(intances) + parseInt(i.count);
                const eccores = sps[0].instanceSizes.filter(co => co.instance_id === i.instance_id);
                if (eccores[0]?.cores) cpus = cpus + parseInt(eccores[0].cores) * i.count;
            });

            setUsedCpus(cpus);
            setUsedIntances(intances);
            setUsedNetwork(network);

            zone?.[0]?.quotas?.cpus && setLimitIntances(zone[0]?.quotas?.cpus);
            zone?.[0]?.quotas?.intance && setLimitCpus(zone[0]?.quotas?.intance);
            zone?.[0]?.quotas?.network && setLimitNetwork(zone[0]?.quotas?.network);
        }
    }, [form, providers, clustersArr]);

    // helper functions
    const getDefaultOsType = () => {
        // If marketplace restricts OS types, prioritize the marketplace OS
        if (marketplaceOSTypes && supportedOSs) {
            const allowedOSs = supportedOSs.filter(os => marketplaceOSTypes.includes(os));
            if (allowedOSs.length > 0) {
                if (form.info['os-type'] && allowedOSs.includes(form.info['os-type'])) {
                    return form.info['os-type'];
                }
                return allowedOSs[0];
            }
        }
        if (supportedOSs.includes(form.info['os-type'])) {
            return form.info['os-type'];
        }
        return supportedOSs[3] || '';
    };

    const handleClose = useCallback(() => {
        dispatch(ActionsDialog.closeDialog())
        dispatch(MarketActions.clearStack())
    }, [dispatch]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleClose]);

    // Initialize image types from form data
    useEffect(() => {
        if (form?.data?.node?.group) {
            const initialTypes = {};
            form.data.node.group.forEach((node, index) => {
                initialTypes[index] = node.image_type || IMAGE_TYPE.HEIDI_STACK;
            });
            setNodeImageTypes(initialTypes);
        }
    }, [form?.data?.node?.group]);
    
    useEffect(() => {
        if (form?.data?.server?.image_type) {
            setServerImageType(form.data.server.image_type);
        }
    }, [form?.data?.server?.image_type]);

    useEffect(() => {
        // Initialize imageMode from form data when editing
        if (form?.info?.imageMode) {
            setImageMode(form.info.imageMode);
        }
    }, [form?.info?.imageMode]);

    // Sync node groups with head node settings when in UNIFIED mode
    useEffect(() => {
        if (imageMode === IMAGE_MODE.UNIFIED && form?.data?.node?.group && form?.data?.server?.image_name) {
            // Update all node groups to use server's image_name as their prefix
            const updatedGroups = form.data.node.group.map(node => ({
                ...node,
                group_node_prefix: form.data.server.image_name,
                image_type: serverImageType
            }));
            
            // Only update if there are actual changes to avoid infinite loops
            const needsUpdate = form.data.node.group.some((node, index) => 
                node.group_node_prefix !== updatedGroups[index].group_node_prefix ||
                node.image_type !== updatedGroups[index].image_type
            );
            
            if (needsUpdate) {
                setForm(prevForm => ({
                    ...prevForm,
                    data: {
                        ...prevForm.data,
                        node: {
                            ...prevForm.data.node,
                            group: updatedGroups
                        }
                    }
                }));
                
                // Also update nodeImageTypes state
                const newTypes = {};
                updatedGroups.forEach((_, index) => {
                    newTypes[index] = serverImageType;
                });
                setNodeImageTypes(newTypes);
            }
        }
    }, [imageMode, serverImageType, form?.data?.server?.image_name]);

    const disableButton = () => setIsFormValid(false);

    const enableButton = () => setIsFormValid(true);

    const handleDeletePackages = pkg => {
        const filteredPkgs = form.data.packages.filter(p => p !== pkg);
        setDataObj({ name: 'packages', value: filteredPkgs });
        const isInPkgs = form.data.packages.some(p => p === pkg);
        const isInDeletedPkgs = deletedPkgs.some(dp => dp === pkg);
        if (isInPkgs && !isInDeletedPkgs) {
            const delArr = form.data.packages.filter(p => p === pkg);
            setDeletedPkgs([...deletedPkgs, ...delArr]);
        }
    };

    const setDataObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, [name]: value }));
    };

    const setNetworkObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'data', { ...form.data, network: { ...form.data.network, [name]: value } }));
    };

    const combineSameConfigurationNodes = groups => {
        const seenGroups = {};
        groups.forEach(group => {
            const compositeId = `${group.group_node_prefix_label}-${group.group_node_prefix}-${group.instance_id}-${group.ocpu}-${group.mem}`;
            if (compositeId in seenGroups)
                seenGroups[compositeId].count = parseInt(seenGroups[compositeId].count) + parseInt(group.count);
            else seenGroups[compositeId] = group;
        });
        const filteredGroups = Object.keys(seenGroups).map(key => seenGroups[key]);
        return filteredGroups;
    };

    // Helper function to check if instance type supports proximity placement groups
    const supportsProximityPlacement = (instanceId) => {
        // HB-series (InfiniBand HPC)
        if (instanceId.startsWith('Standard_HB')) return true;
        // HC-series (InfiniBand HPC)
        if (instanceId.startsWith('Standard_HC')) return true;
        // ND-series (GPU with InfiniBand)
        if (instanceId.startsWith('Standard_ND')) return true;
        // NC-series (GPU workloads)
        if (instanceId.startsWith('Standard_NC')) return true;
        // H-series with InfiniBand
        if (instanceId === 'Standard_H16r' || instanceId === 'Standard_H16mr') return true;
        return false;
    };

    // Helper function to check if any instance in the cluster supports proximity placement
    const shouldEnableProximityPlacement = (form) => {
        // Check server instance
        if (form?.data?.server?.instance_id && supportsProximityPlacement(form.data.server.instance_id)) {
            return true;
        }
        
        // Check node group instances
        if (form?.data?.node?.group) {
            return form.data.node.group.some(group => 
                group.instance_id && supportsProximityPlacement(group.instance_id)
            );
        }
        
        return false;
    };

    const setInstanceId = (i = 0, value) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        const groups = form.data.node.group;
        groups[i]['instance_id'] = value;
        if (!value.includes('Flex')) {
            setNodeOCPUS(i, 1);
            setNodeMEM(i, 1);
        }
        const groupFiltered = combineSameConfigurationNodes(groups);
        
        // Update form with new node groups
        const updatedForm = _.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } });
        
        // Set proximity placement based on whether any instance type supports it
        updatedForm.data.network.use_proximity_placement = shouldEnableProximityPlacement(updatedForm);
        
        setForm(updatedForm);
    };
    const setNodePrefix = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };
    const setNodePrefixLabel = (i = 0, value) => {
        const groups = form.data.node.group;
        groups[i]['group_node_prefix_label'] = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    }
    // TODO: I implemented this the way that other things are currently being implemented.
    // This could be refactored.
    const setNodeMEM = (i, value) => {
        const groups = form.data.node.group;
        groups[i].mem = value;
        const groupFiltered = combineSameConfigurationNodes(groups);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };
    const setInstanceCount = (i, { name, value }) => {
        const group = form.data.node.group;
        group[i][name] = value;

        const groupFiltered = combineSameConfigurationNodes(group);
        setForm(_.set({ ...form }, 'data', { ...form.data, node: { ...form.data.node, group: [...groupFiltered] } }));
    };
    const setServerObj = ({ name, value }) => {
        //Fix the issue of entering wrong CPUS and MEM for Flex instance will not allow you to Save the Cluster info if the user
        //decided to choose a normal / NON Flex instance
        if (name === 'instance_id' && !value.includes('Flex')) {
            form.data.server.ocpus = form.data.server.mem = 1;
        }
        
        // Update form with new server instance
        const updatedForm = _.set({ ...form }, 'data', { ...form.data, server: { ...form.data.server, [name]: value } });
        
        // Set proximity placement based on whether any instance type supports it (when changing instance_id)
        if (name === 'instance_id') {
            updatedForm.data.network.use_proximity_placement = shouldEnableProximityPlacement(updatedForm);
        }
        
        setForm(updatedForm);
    };
    const setInfoObj = ({ name, value }) => {
        setForm(_.set({ ...form }, 'info', { ...form.info, [name]: value }));
    };

    // Image type handler functions
    const handleServerImageTypeChange = (e) => {
        const newValue = e.target.value;
        setServerImageType(newValue);
        setForm(prevForm => ({
            ...prevForm,
            data: {
                ...prevForm.data,
                server: {
                    ...prevForm.data.server,
                    image_type: newValue
                }
            }
        }));
    };

    const setNodeImageType = (index, type) => {
        setNodeImageTypes(prev => ({
            ...prev,
            [index]: type
        }));
        
        setForm(prevForm => {
            const updatedGroups = [...prevForm.data.node.group];
            updatedGroups[index] = {
                ...updatedGroups[index],
                image_type: type
            };
            return {
                ...prevForm,
                data: {
                    ...prevForm.data,
                    node: {
                        ...prevForm.data.node,
                        group: updatedGroups
                    }
                }
            };
        });
    };

    const setNodeOCPUS = (i, value) => {
        const groups = form.data.node.group;
        groups[i].ocpus = value;
    };
    const setPackagesArr = () => {
        const pkg = pkgRef.current.value;
        setForm(_.set({ ...form }, 'data', { ...form.data, packages: [...form.data.packages, pkg] }));
        pkgRef.current.value = null;
    };

    const handleUpload = e => {
        const file = e.target.files[0];
        if (!file) return;

        //reset value to '' so that the same file can be uploaded if removed
        e.target.value = '';

        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
            setForm(
                _.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: reader.result } })
            );
        };
    };

    const areNonFormsyRequiredFieldsValid = () => {
        // check that the server prefix and all of the prefixes of compute nodes are in a non-error state and have content
        const serverPrefixisValid = !prefixError && form.data.server.image_name
        const nodePrefixesAreValid = nodePrefixErrors.every(error => error === '') && form.data.node.group.every(node => node.group_node_prefix)
        return serverPrefixisValid && nodePrefixesAreValid
    }

    //Validation functions
    const validationInput = (type, instanceid, currentvalue, ocpus, provider) => {
        return validationInputUlt(type, instanceid, currentvalue, ocpus, provider);
    };

    const validationMess = (type, instanceid, ocpus, provider, currentMarketStack) => {
        return validationMessUlt(type, instanceid, ocpus, provider, currentMarketStack);
    };

    const handleDeleteScript = () => {
        setForm(_.set({ ...form }, 'data', { ...form.data, provision: { ...form.data.provision, script: '' } }));
    };

    const addComputeNode = () => {
        if (form.data.node.group.length < 250) {
            // Create a new node with appropriate sequential label
            const newNodeIndex = form.data.node.group.length + 1;
            const initialValues = { 
                ...form.data.node.group[0], 
                count: 1,
                group_node_prefix_label: `Node Group ${newNodeIndex}`
            };
            setForm((prevForm) => ({
                ...prevForm, data: { ...prevForm.data, node: { ...prevForm.data.node, group: [...prevForm.data.node.group, initialValues] } }
            }
            ));
        }
    }

    const removeComputeNode = (i) => {
        if (form.data.node.group.length > 1) {
            setForm((prevForm) => {
                const group = [...prevForm.data.node.group];
                group.splice(i, 1);
                
                // Renumber the remaining nodes to maintain sequential labels
                const updatedGroup = group.map((node, index) => ({
                    ...node,
                    group_node_prefix_label: `Node Group ${index + 1}`
                }));
                
                return { 
                    ...prevForm, 
                    data: { 
                        ...prevForm.data, 
                        node: { 
                            ...prevForm.data.node, 
                            group: updatedGroup 
                        } 
                    } 
                };
            });
        }
    }

    useEffect(() => {
        if (form && form.data && form.data.node && form.data.node.group) {
            // When the form first loads, ensure all node groups have proper sequential labels
            const updatedGroup = form.data.node.group.map((node, index) => ({
                ...node,
                group_node_prefix_label: `Node Group ${index + 1}`
            }));
            
            if (JSON.stringify(updatedGroup) !== JSON.stringify(form.data.node.group)) {
                setForm({
                    ...form,
                    data: {
                        ...form.data,
                        node: {
                            ...form.data.node,
                            group: updatedGroup
                        }
                    }
                });
            }
        }
    }, [form?.data?.node?.group?.length]);

    const startSave = () => handleSave({ confirmed: false });
    const startEdit = () => handleEdit({ confirmed: false });

    const handleEdit = ({ confirmed }) => {
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }
        if (error) {
            dispatch(Actions.clearError());
        }
        //reset lastDeployTime & lastDestroyTime
        if (form?.info?.lastDeployTime) form.info.lastDeployTime = 0;
        if (form?.info?.lastDestroyTime) form.info.lastDestroyTime = 0;

        // Create a copy of the form like AWS handleEdit does
        const updatedForm = {
            ...form,
            excludedGlobalScripts,
            applications: clusterApplications || [],
            data: {
                ...form.data,
                network: {
                    ...form.data.network,
                    enable_node_internet_access: enableNodeInternetAccess,
                    enable_capacity_reservation: enableCapacityReservation,
                    capacity_reservation_auto_expire: capacityReservationAutoExpire,
                    capacity_reservation_expire_hours: capacityReservationExpireHours
                }
            }
        };

        if (isMarketStack) updatedForm.data.marketplace_image_reference = marketplace_image_reference;
        
        // Apply image types to form data
        updatedForm.data.server.image_type = serverImageType;
        updatedForm.data.node.group.forEach((node, index) => {
            node.image_type = nodeImageTypes[index] || IMAGE_TYPE.HEIDI_STACK;
        });

        // Set imageMode in info object (matches schema)
        updatedForm.info.imageMode = imageMode;

        // Add owner selection if super-admin selected a different owner
        let ownerUsername;
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            ownerUsername = selectedOwner;
            // Ensure the form's user field matches the ownerUsername being sent
            updatedForm.user = [ownerUsername];
            // Also update the owner field with the correct user ID
            const selectedUser = users.find(user => user.name === selectedOwner);
            if (selectedUser) {
                updatedForm.owner = selectedUser.id; // Use 'id' instead of '_id'
            }
        }

        dispatch(Actions.editCluster(updatedForm, deletedPkgs, ownerUsername));
    };
    const handleSave = ({ confirmed }) => {
        if (props.setOldForm) {
            props.setOldForm(form);
        }
        if (confirmed) {
            dispatch(ActionsDialog.closeDialog());
        }

        const updatedForm = {
            ...form,
            excludedGlobalScripts,
            applications: clusterApplications || [],
            data: {
                ...form.data,
                network: {
                    ...form.data.network,
                    enable_node_internet_access: enableNodeInternetAccess,
                    enable_capacity_reservation: enableCapacityReservation,
                    capacity_reservation_auto_expire: capacityReservationAutoExpire,
                    capacity_reservation_expire_hours: capacityReservationExpireHours
                },
                server: {
                    ...form.data.server,
                    image_type: serverImageType
                },
                marketplace_image_reference: isMarketStack ? marketplace_image_reference : null,
            },
            info: {
                ...form.info,
                prefix: inputValue,
                isMarketplace: isMarketStack,
                market_id: market_id_value,
                marketplace_head_image_id: marketplace_head_image_id,
                marketplace_compute_image_id: marketplace_compute_image_id,
                "os-type": form.info['os-type'],
				vncTokenAuthentication: isVncTokenAuthentication,
                vncRemoteClient: isVncRemoteClient,
                imageMode: imageMode
            },
            provider: 'azure'
        }

        // Apply node image types
        updatedForm.data.node.group = updatedForm.data.node.group.map((node, index) => ({
            ...node,
            image_type: nodeImageTypes[index] || IMAGE_TYPE.HEIDI_STACK
        }));

        // Add owner selection if super-admin selected a different owner
        const saveData = { ...updatedForm };
        if (currentUser.role && currentUser.role.includes('super-admin') && selectedOwner) {
            saveData.ownerUsername = selectedOwner;
        }

        setForm(updatedForm);
        dispatch(Actions.saveCluster(saveData));
    };

    // Popover delay and close handlers
    //const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    const handlePopoverOpen = async event => {
        const targettemp = event.currentTarget;
        handlePopoverClose();
        if (popovertarget !== targettemp) {
            clearTimeout(timeoutid);
            setTimeout(() => setAnchorEl(null), 0);
            setTimeout(() => setAnchorEl(targettemp), 0);
            setPopovertarget(targettemp);
            setTimeoutid(setTimeout(handlePopoverClose, 4000));
        } else {
            clearTimeout(timeoutid);
            const targettemp = event.currentTarget;
            setTimeout(() => setAnchorEl(targettemp), 0);
            setTimeoutid(setTimeout(handlePopoverClose, 4000));
        }
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        clearTimeout(timeoutid);
    };

    const isODDCBurstingSelectionEnabled = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/moab/isIntegrated`)
            if (response.status !== 200) return false
            return response.data.isIntegrated
        } catch (error) {
            console.error('Error fetching from API:', error)
        }
    }

    const [moabIsIntegrated, setMoabIsIntegrated] = useState(null);

    useEffect(() => {
        const fetchDataAsync = async () => {
            const isIntegrated = await isODDCBurstingSelectionEnabled();
            setMoabIsIntegrated(isIntegrated);
        };

        fetchDataAsync();
    }, []);

    const [burstMode, setBurstMode] = useState(null)

    useEffect(() => {
        if (burstMode !== null) return
        if (props.type === 'new') {
            if (currentMarketStack ?
                setBurstMode('off') : setBurstMode('off'));
            return
        }
        if (form?.info?.bursting?.mode) setBurstMode(form.info.bursting.mode)
    }, [form, burstMode, currentMarketStack, props.type]);

    useEffect(() => {
        const initialValues = form?.data?.node?.group.map(group => group.group_node_prefix || '');
        setGroupNodeInputValues(initialValues);
    }, [form]);

    useEffect(() => {
        if (burstMode === null) return
        if (!form?.info) return
        form.info.bursting.mode = burstMode
    }, [form, burstMode]);

    // Add this useEffect to reset burst mode when manager changes from Torque to something else
    useEffect(() => {
        if (form?.data?.manager && form.data.manager !== RESOURCE_MANAGER.TORQUE && burstMode !== 'off') {
            setBurstMode('off');
        }
    }, [form?.data?.manager, burstMode]);

    const validateServerPrefix = (prefix) => {
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        if (/[^a-z0-9-]/g.test(prefix)) setPrefixError(invalidPrefixCharacter);
        else if (/^-|-$|--/g.test(prefix)) setPrefixError(invalidPrefixHyphenUsage);
        else setPrefixError('');
    }

    const validateNodePrefix = (prefix, index) => {
        const invalidPrefixCharacter = 'Invalid characters in the prefix. Use only lowercase letters, numbers, and hyphens.';
        const invalidPrefixHyphenUsage = 'Hyphens cannot start or end the prefix, and consecutive hyphens are not allowed.';
        let error = '';
        if (/[^a-z0-9-]/g.test(prefix)) error = invalidPrefixCharacter;
        else if (/^-|-$|--/g.test(prefix)) error = invalidPrefixHyphenUsage;

        setNodePrefixErrors(prevErrors => {
            const newErrors = [...prevErrors];
            newErrors[index] = error;
            return newErrors;
        });
    };

    useEffect(() => {
        const downloadProvisionScript = async () => {
            if (
                currentMarketStack?.config?.provision_script && 
                form?.data?.provision &&
                !form.data.provision.script // Only download if no script already exists
            ) {
                dispatch(ActionsDialog.toggleLoading());
                try {
                    const scriptContent = await dispatch(MarketActions.getProvisionScript(currentMarketStack.config.provision_script));
                    setForm(_.set({ ...form }, 'data', { 
                        ...form.data, 
                        provision: { 
                            ...form.data.provision, 
                            script: scriptContent 
                        } 
                    }));
                } catch (error) {
                    console.error("Error downloading provision script:", error);
                } finally {
                    dispatch(ActionsDialog.toggleLoading());
                }
            }
        };
        
        downloadProvisionScript();
    }, [currentMarketStack, form, dispatch, setForm]);

    return (
        <React.Fragment>
            {form && (
                <React.Fragment>
                    {/* Title & actions */}
                    <DialogTitle className={clsx(classes.modalHeader, 'h-54 p-20')}>
                        <div className="flex flex-1 w-full items-center justify-between">
                            <div className="flex flex-col max-w-full">
                                <div className="flex items-center max-w-full">
                                    <FuseAnimate animation="transition.expandIn" delay={300}>
                                        <img
                                            id="azure_provider-logo"
                                            className="w-32 sm:w-48 mr-8 sm:mr-16 rounded"
                                            src={imageSrc}
                                            alt="Provider Logo"
                                        />
                                    </FuseAnimate>
                                    <div className="flex flex-col min-w-0">
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <Typography id="azure_cluster-name-header" className="text-16 text-white sm:text-20 truncate">
                                                {title}
                                            </Typography>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            </div>
                            <div>
									<Button
                                    className="whitespace-no-wrap mr-2"
                                    id="azure_advanced-btn"
                                    variant="contained"
                                    disabled={loading}
                                    onClick={() => setAdvanced(!advanced)}
                                >
                                    Advanced
                                </Button>
                                {props.type === 'new' && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="azure_save-btn"
                                        disabled={
                                            !isFormValid ||
                                            !areNonFormsyRequiredFieldsValid()
                                        }
                                        variant="contained"
                                        onClick={() => {
                                            startSave();
                                            dispatch(MarketActions.clearStack());
                                        }}
                                    >
                                        {'Save'}
                                    </Button>
                                )}
								{props.type === 'edit' && form.info.state === CLUSTER_STATES.DESTROYED && (
                                    <Button
                                        className="whitespace-no-wrap mx-2"
                                        id="azure_save-btn"
                                        disabled={!isFormValid || loading || !form.data.server.image_name}
                                        variant="contained"
                                        onClick={() => {
                                            startEdit()
                                            dispatch(MarketActions.clearStack())
                                        }}
                                    >
                                        update
                                    </Button>
                                )}
                                <Button
                                    className="whitespace-no-wrap ml-2"
                                    id="azure_close-btn"
                                    variant="contained"
                                    onClick={handleClose}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>

                    {/* Quota warnings (unchanged) */}
                    {(usedCpus > limitCpus || usedNetwork > limitNetwork || usedIntances > limitIntances) && (
                        <Box p={2} my={2} bgcolor="#FFF3E0" borderRadius={1}>
                            {usedCpus > limitCpus && (
                                <span className={classes.error2}>
                                    <Icon>error</Icon> <span>The quota of CPUs established by the provider is exceeded</span>
                                </span>
                            )}
                            {usedNetwork > limitNetwork && (
                                <span className={classes.error2}>
                                    <Icon>error</Icon> <span>The quota of network established by the provider is exceeded</span>
                                </span>
                            )}
                            {usedIntances > limitIntances && (
                                <span className={classes.error2}>
                                    <Icon>error</Icon> <span>The quota of Intances established by the provider is exceeded</span>
                                </span>
                            )}
                        </Box>
                    )}

                    <DialogContent className={clsx(classes.content, 'p-16 -mr-200 ml-20')}>
                        <DisabledFormWrapper isDisabled={disableInputs}>
                            <Formsy ref={formRef} onValid={enableButton} onInvalid={disableButton}>
                                <OwnerSelectionCard
                                    value={selectedOwner}
                                    onChange={setSelectedOwner}
                                    label="Cluster Owner"
                                    title="Cluster Owner"
                                    showInAdvancedMode={true}
                                    advanced={advanced}
                                    disabled={props.type === 'edit' && form && form.info && form.info.state !== CLUSTER_STATES.DESTROYED}
                                />

                                {/* Basic Information */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Box display="flex" alignItems="center">
                                                    <Icon className="mr-8">info</Icon>
                                                    <Typography style={sectionTitleStyle}>Basic Information</Typography>
                                                </Box>
                                                {props.type === 'edit' && form?.id && (
                                                    <Typography style={{color: '#666', fontSize: '14px', fontWeight: 'normal'}}>
                                                        ID: {form.id}
                                                    </Typography>
                                                )}
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            {/* Left Column - fixed width */}
                                            <div style={{ width: '48%' }}>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'mr-16')}
                                                    style={{ marginBottom: '16px', width: '150%' }}
                                                    id="azure_name"
                                                    name="name"
                                                    label="Cluster Name"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.name}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="Your Cluster Name (No Spaces or Capitals)"
                                                    validations={{
                                                        isNameUnique: (formValues, fieldValue) => {
                                                            if (clusterNames.includes(fieldValue) && !(props.type === 'edit')) {
                                                                return 'This name is already in use. Please choose a different one.';
                                                            }
                                                            return true;
                                                        },
                                                        isString: (formValues, fieldValue) => typeof fieldValue === 'string' || 'Name must be a string.',
                                                        doesNotExceedMaxLength: (formValues, fieldValue) =>
                                                            !fieldValue || fieldValue.length <= 15 || 'Name cannot exceed 15 characters.',
                                                        hasValidCharacters: (formValues, fieldValue) =>
                                                            !fieldValue || !/[^a-z0-9-]/g.test(fieldValue) || 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                                        doesNotStartOrEndWithHyphen: (formValues, fieldValue) =>
                                                            !fieldValue || !/^-|-$|--/g.test(fieldValue) || 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                                        doesNotStartWithInteger: (formValues, fieldValue) =>
                                                            !fieldValue || !/^\d/.test(fieldValue) || 'Name cannot start with a number.',
                                                    }}
                                                    validationErrors={{
                                                        isNameUnique: 'This name is already in use. Please choose a different one.',
                                                        isString: 'Name must be a string.',
                                                        doesNotExceedMaxLength: 'Name cannot exceed 15 characters.',
                                                        hasValidCharacters: 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.',
                                                        doesNotStartOrEndWithHyphen: 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.',
                                                        doesNotStartWithInteger: 'Name cannot start with a number.'
                                                    }}
                                                />
                                                <SelectFormsy
                                                    className={clsx(classes.input)}
                                                    id="azure_os-type"
                                                    name="os-type"
                                                    label="Operating System"
                                                    type="select"
                                                    variant="outlined"
                                                    value={getDefaultOsType()}
                                                    onChange={e => setInfoObj(e.target)}
                                                    required
                                                    disabled={marketplaceOSTypes && supportedOSs.filter(os => marketplaceOSTypes.includes(os)).length === 1}
                                                    style={{ width: '400px' }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { maxHeight: 300 }
                                                        }
                                                    }}
                                                >
                                                    {
                                                        supportedOSs
                                                            .filter(os => !marketplaceOSTypes || marketplaceOSTypes.includes(os))
                                                            .map((os, index) => (
                                                                <MenuItem id={`os-${os}`} key={index} value={os}>
                                                                    {os}
                                                                </MenuItem>
                                                            ))}
                                                </SelectFormsy>
                                            </div>

                                            {/* Divider - centered */}
                                            <div style={{ 
                                                width: '2px', 
                                                backgroundColor: '#e0e0e0', 
                                                margin: '10px 0',
                                                alignSelf: 'stretch'
                                            }} />

                                            {/* Right Column - fixed width */}
                                            <div style={{ width: '48%' }}>
                                                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                                    <TextField
                                                        ref={textFieldRef}
                                                        label="Stack"
                                                        className={clsx(classes.input)}
                                                        style={{ flex: 1 }}
                                                        placeholder="Your Image Name or Select Stack"
                                                        required
                                                        disabled={Boolean(currentMarketStack)}
                                                        value={form.data.server.image_name || ''}
                                                        onChange={e => {
                                                            form.data.server.image_name = e.target.value
                                                            setForm({ ...form }) //done for rerender
                                                            validateServerPrefix(e.target.value)
                                                        }}
                                                        variant="outlined"
                                                        error={prefixError ? true : false}
                                                        helperText={prefixError}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="start">
                                                                    <IconButton
                                                                        disabled={Boolean(currentMarketStack)}
                                                                        onClick={handleMenuOpen}>
                                                                        <ArrowDropDownIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                    
                                                    <SelectFormsy
                                                        className={clsx(classes.input)}
                                                        id="azure_server_image_type"
                                                        name="server_image_type"
                                                        label="Image Type"
                                                        type="select"
                                                        variant="outlined"
                                                        value={serverImageType}
                                                        onChange={handleServerImageTypeChange}
                                                        style={{ width: '180px' }}
                                                        disabled={Boolean(currentMarketStack)}
                                                    >
                                                        <MenuItem value={IMAGE_TYPE.HEIDI_STACK}>Heidi Stack</MenuItem>
                                                        <MenuItem value={IMAGE_TYPE.CUSTOM_STACK}>Custom Stack</MenuItem>
                                                    </SelectFormsy>
                                                </div>
                                                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginTop: '16px' }}>
                                                    <SelectFormsy
                                                        className={clsx(classes.input)}
                                                        id="azure_image_mode"
                                                        name="image_mode"
                                                        label="Image Mode"
                                                        type="select"
                                                        variant="outlined"
                                                        value={imageMode}
                                                        onChange={e => setImageMode(e.target.value)}
                                                        style={{ width: '220px' }}
                                                        disabled={Boolean(currentMarketStack)}
                                                    >
                                                        <MenuItem value={IMAGE_MODE.MULTI_IMAGE}>Multi-Image (Legacy)</MenuItem>
                                                        <MenuItem value={IMAGE_MODE.UNIFIED}>Unified (Single Image)</MenuItem>
                                                    </SelectFormsy>
                                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px', maxWidth: '300px' }}>
                                                        {imageMode === IMAGE_MODE.UNIFIED
                                                            ? 'Single unified image for head and compute nodes'
                                                            : 'Separate images for head node and compute nodes'}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>

                                {/* Two-column layout for Infrastructure and Resource Manager */}
                                <div style={columnContainerStyle}>
                                    {/* Left Column - Infrastructure */}
                                    <div style={columnStyle}>
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon className="mr-8">cloud</Icon>
                                                        <Typography style={sectionTitleStyle}>Infrastructure</Typography>
                                                    </Box>
                                                }
                                                action={
                                                    form && form.data && form.data.network && form.data.network.region_id ? (
                                                        <ZoneAvailabilityIndicator
                                                            isLoading={isAvailabilityLoading}
                                                            isAvailable={azureRegionAvailable}
                                                            missingInstances={azureMissingInstances}
                                                            error={availabilityError}
                                                            unableToVerify={unableToVerify}
                                                        />
                                                    ) : null
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                <div className="flex flex-row my-16 w-full">
                                                    <SelectFormsy
                                                        className={clsx(classes.input, 'w-1/2 mr-8')}
                                                        id="azure_credential_id"
                                                        name="credential_id"
                                                        label="Credential *"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.credential_id}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        {filteredCredentials.map((c, i) => (
                                                            <MenuItem id={c.name} key={i} value={c.id}>
                                                                {c.name}
                                                            </MenuItem>
                                                        ))}
                                                    </SelectFormsy>
                                                    <SelectFormsy
                                                        className={clsx(classes.input, 'w-1/2 ml-8')}
                                                        id="azure_server-instance_id"
                                                        name="instance_id"
                                                        label="Head Node Size *"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.server.instance_id}
                                                        onChange={e => setServerObj(e.target)}
                                                        fullWidth
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        {
                                                            serverInstanceSizes
                                                                .filter(s => !marketplaceInstanceIds || marketplaceInstanceIds.includes(s.instance_id))
                                                                .map((s, i) => (
                                                                    <MenuItem
                                                                        id={`server-${s.name}`}
                                                                        key={i}
                                                                        value={s.instance_id}
                                                                    >
                                                                        {s.name}
                                                                    </MenuItem>
                                                                ))
                                                        }
                                                    </SelectFormsy>
                                                </div>
                                                <div className="flex flex-row my-16 w-full">
                                                    <SelectFormsy
                                                        className={clsx(classes.input, 'w-full mr-8')}
                                                        id="azure_region_id"
                                                        name="region_id"
                                                        label="Region *"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.network.region_id}
                                                        onChange={e => setNetworkObj(e.target)}
                                                        fullWidth
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 300 }
                                                            }
                                                        }}
                                                    >
                                                        {
                                                            regions
                                                                .filter(region => !marketplaceRegionIds || marketplaceRegionIds.includes(region.region_id))
                                                                .map((region, index) => (
                                                                    <MenuItem id={region.name} key={index} value={region.region_id}>
                                                                        {region.name}
                                                                    </MenuItem>
                                                                ))}
                                                    </SelectFormsy>
                                                    <TextFieldFormsy
                                                        className={clsx(classes.input, 'ml-8')}
                                                        id="azure_image_resource_group_name"
                                                        name="image_resource_group_name"
                                                        label="Image Resource Group Name"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.image_resource_group_name}
                                                        onChange={e => setDataObj(e.target)}
                                                        fullWidth
                                                        required
                                                        placeholder="Exp: Image_group_1"
                                                    />
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>

                                    {/* Right Column - Resource Manager */}
                                    <div style={columnStyle}>
                                        <Card style={cardStyle}>
                                            <CardHeader
                                                title={
                                                    <Box display="flex" alignItems="center">
                                                        <Icon className="mr-8">settings_applications</Icon>
                                                        <Typography style={sectionTitleStyle}>Resource Manager Configuration</Typography>
                                                    </Box>
                                                }
                                                style={cardHeaderStyle}
                                            />
                                            <CardContent>
                                                <div className="flex flex-row my-16 w-full gap-4">
                                                    <SelectFormsy
                                                        className={clsx(classes.input, "flex-1 mr-8")}
                                                        id="azure_manager"
                                                        name="manager"
                                                        label="Manager"
                                                        type="select"
                                                        variant="outlined"
                                                        value={form.data.manager}
                                                        onChange={e => setDataObj(e.target)}
                                                        required
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: { maxHeight: 200 }
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem id="azure_none" value="none">
                                                            None
                                                        </MenuItem>
                                                        <MenuItem id="azure_slurm" value="slurm">
                                                            Slurm
                                                        </MenuItem>
                                                        <MenuItem id="azure_torque" value="torque">
                                                            Torque
                                                        </MenuItem>
                                                    </SelectFormsy>
                                                    
                                                    <TextField
                                                        className={clsx(classes.input, "flex-1 mr-8")}
                                                        id="azure_hostname"
                                                        name="hostname"
                                                        label="Host Name"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.hostname || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder="Host Name"
                                                        onChange={e => setClusterInfo(e)}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                // Prevent any click interactions when disabled
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                    />
                                                    
                                                    <TextField
                                                        className={clsx(classes.input, "flex-1")}
                                                        id="azure_ip"
                                                        name="ip"
                                                        label={
                                                            form.data.server.isPrivate ?
                                                                'Private IP'
                                                                : 'Public IP'
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.moab.ip || ''}
                                                        fullWidth
                                                        required={form.data.manager === RESOURCE_MANAGER.TORQUE}
                                                        disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}
                                                        placeholder={
                                                            form.data.server.isPrivate
                                                                ? 'Private IP'
                                                                : 'Public IP'
                                                        }
                                                        onChange={e => setClusterInfo(e)}
                                                        InputProps={{
                                                            readOnly: form.data.manager !== RESOURCE_MANAGER.TORQUE,
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledInput : '',
                                                                notchedOutline: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledOutline : '',
                                                            },
                                                            style: {
                                                                // Prevent any click interactions when disabled
                                                                pointerEvents: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'none' : 'auto'
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: form.data.manager !== RESOURCE_MANAGER.TORQUE ? classes.disabledLabel : ''
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: form.data.manager !== RESOURCE_MANAGER.TORQUE ? 'rgba(0, 0, 0, 0.38)' : 'inherit'
                                                            }
                                                        }}
                                                        error={Boolean(form.data.manager === RESOURCE_MANAGER.TORQUE && form.data.moab.ip && !ipValid(form.data.moab.ip))}
                                                        helperText={form.data.manager === RESOURCE_MANAGER.TORQUE && form.data.moab.ip && !ipValid(form.data.moab.ip) ? 'Not a valid IP' : ''}
                                                    />
                                                </div>
                                                
                                                {moabIsIntegrated && !currentMarketStack && (
                                                    <Box mt={2} sx={form.data.manager !== RESOURCE_MANAGER.TORQUE ? { opacity: 0.6 } : {}}>
                                                        <Typography variant="subtitle2" style={{marginBottom: '8px'}}>Bursting Configuration:</Typography>
                                                        <FormControl component="fieldset" disabled={form.data.manager !== RESOURCE_MANAGER.TORQUE}>
                                                            <RadioGroup
                                                                row
                                                                id="azure_burstOnDeploy"
                                                                name="burstOnDeploy"
                                                                value={burstMode}
                                                                onChange={e => {
                                                                    if (form.data.manager === RESOURCE_MANAGER.TORQUE) {
                                                                        const mode = e.target.value;
                                                                        setBurstMode(mode);
                                                                    }
                                                                }}
                                                            >
                                                                <FormControlLabel 
                                                                    value="off" 
                                                                    id="azure_radio-off" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Off" 
                                                                />
                                                                <FormControlLabel 
                                                                    value="min" 
                                                                    id="azure_radio-min" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Min" 
                                                                />
                                                                <FormControlLabel 
                                                                    value="max" 
                                                                    id="azure_radio-max" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="Max" 
                                                                />
                                                                <FormControlLabel 
                                                                    value="all" 
                                                                    id="azure_radio-all" 
                                                                    control={<Radio color="primary" />} 
                                                                    label="All" 
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>

                                {/* Advanced: VNC Settings & Provisioning Script in two columns */}
                                {advanced && (
                                    <div style={columnContainerStyle}>
                                        {/* Left Column - VNC Settings */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon className="mr-8">desktop_windows</Icon>
                                                            <Typography style={sectionTitleStyle}>VNC Settings</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                                    <div className="flex flex-row items-center justify-start">
                                                        <div className="flex flex-row items-center justify-start w-1/2 mr-8">
                                                            VNC Token Authentication:
                                                            <Checkbox
                                                                checked={isVncTokenAuthentication}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked; 
                                                                    setIsVncTokenAuthentication(newValue); 
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        info: {
                                                                            ...prevForm.info,
                                                                            vncTokenAuthentication: newValue 
                                                                        }
                                                                    }));
                                                                }}
                                                                name="vncTokenAuthentication"
                                                                color="primary"
                                                            />
                                                        </div>
                                                        <div className="flex flex-row items-center justify-start w-1/2 ml-8">
                                                            VNC Remote Client:
                                                            <Checkbox
                                                                checked={isVncRemoteClient}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked;
                                                                    setIsVncRemoteClient(newValue);
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        info: {
                                                                            ...prevForm.info,
                                                                            vncRemoteClient: newValue
                                                                        }
                                                                    }));
                                                                }}
                                                                name="vncRemoteClient"
                                                                color="primary"
                                                            />
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        
                                        {/* Right Column - Provisioning Script (hidden for marketplace apps with hide_provision_script) */}
                                        {!marketplaceHideProvisionScript && (
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon className="mr-8">code</Icon>
                                                            <Typography style={sectionTitleStyle}>Provisioning Script</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                                    <div className="flex flex-row items-center justify-between">
                                                        <div className="flex items-center" style={{ position: 'relative' }}>
                                                            <input
                                                                className={classes.uploadInput}
                                                                onChange={e => handleUpload(e)}
                                                                id="azure_upload-btn"
                                                                type="file"
                                                                disabled={disableScriptModification}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    opacity: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    cursor: disableScriptModification ? 'not-allowed' : 'pointer',
                                                                    zIndex: 1
                                                                }}
                                                            />
                                                            <label htmlFor="azure_upload-btn">
                                                                <Button
                                                                    id="azure_upload-label"
                                                                    variant="contained" 
                                                                    size="small" 
                                                                    className={classes.grayButton}
                                                                    startIcon={<Icon>cloud_upload</Icon>}
                                                                    component="span"
                                                                    disabled={disableScriptModification}
                                                                >
                                                                    Upload Script
                                                                </Button>
                                                            </label>
                                                        </div>
                                                        
                                                        {!form.data.provision.script ? (
                                                            <Typography variant="body2" color="textSecondary">
                                                                No Script
                                                            </Typography>
                                                        ) : (
                                                            <div className="flex items-center">
                                                                <Chip 
                                                                    label="Script Uploaded" 
                                                                    color="primary" 
                                                                    size="small"
                                                                    style={{marginRight: '8px'}}
                                                                />
                                                                {!disableScriptModification && (
                                                                    <IconButton size="small" onClick={handleDeleteScript}>
                                                                        <Icon fontSize="small">delete</Icon>
                                                                    </IconButton>
                                                                )}
                                                                <IconButton id="script-actions-view-button" size="small" onClick={() => setScriptOpen(true)}>
                                                                    <Icon fontSize="small">visibility</Icon>
                                                                </IconButton>
                                                            </div>
                                                        )}
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        )}
                                    </div>
                                )}

                                {/* Global Provision Scripts Preview */}
                                {/* Always render when disable_global_scripts is set (so configs load for auto-exclude), but hide the UI */}
                                {(advanced || marketplaceDisableGlobalScripts) && (
                                    <div style={marketplaceDisableGlobalScripts ? { display: 'none' } : undefined}>
                                        <GlobalProvisionScriptsPreview
                                            provider="azure"
                                            osType={form?.info?.['os-type']}
                                            clusterName={form?.name}
                                            clusterId={form?.id}
                                            excludedScripts={excludedGlobalScripts}
                                            onExcludedScriptsChange={setExcludedGlobalScripts}
                                            disabled={disableInputs || marketplaceDisableGlobalScripts}
                                        />
                                    </div>
                                )}

                                {/* Cluster Applications - visible in both Basic and Advanced modes when apps exist */}
                                {(advanced || clusterApplications.length > 0) && (
                                    <ClusterApplicationsSection
                                        applications={clusterApplications}
                                        onChange={setClusterApplications}
                                        disabled={disableInputs}
                                        cardStyle={cardStyle}
                                        cardHeaderStyle={cardHeaderStyle}
                                        sectionTitleStyle={sectionTitleStyle}
                                    />
                                )}

                                {/* Network Settings and Capacity Reservations - Side by Side */}
                                {advanced && (
                                    <div style={columnContainerStyle}>
                                        {/* Left column - Network Settings */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>cloud_queue</Icon>
                                                            <Typography style={sectionTitleStyle}>Network Settings</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={enableNodeInternetAccess}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked;
                                                                    setEnableNodeInternetAccess(newValue);
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        data: {
                                                                            ...prevForm.data,
                                                                            network: {
                                                                                ...prevForm.data.network,
                                                                                enable_node_internet_access: newValue
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                name="enableNodeInternetAccess"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={
                                                            <Box>
                                                                <Typography variant="body1" style={{fontWeight: 500}}>
                                                                    Enable Node Internet Access
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                    Create NAT Gateway for outbound internet connectivity.
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />
                                                </CardContent>
                                            </Card>
                                        </div>

                                        {/* Right column - Capacity Reservations */}
                                        <div style={columnStyle}>
                                            <Card style={{...cardStyle, height: '100%'}}>
                                                <CardHeader
                                                    title={
                                                        <Box display="flex" alignItems="center">
                                                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>how_to_reg</Icon>
                                                            <Typography style={sectionTitleStyle}>Capacity Reservations</Typography>
                                                        </Box>
                                                    }
                                                    style={cardHeaderStyle}
                                                />
                                                <CardContent>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={enableCapacityReservation}
                                                                onChange={event => {
                                                                    const newValue = event.target.checked;
                                                                    setEnableCapacityReservation(newValue);
                                                                    setForm(prevForm => ({
                                                                        ...prevForm,
                                                                        data: {
                                                                            ...prevForm.data,
                                                                            network: {
                                                                                ...prevForm.data.network,
                                                                                enable_capacity_reservation: newValue
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                name="enableCapacityReservation"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={
                                                            <Box>
                                                                <Typography variant="body1" style={{fontWeight: 500}}>
                                                                    Reserve Capacity Before Deploy
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                    Validate instance availability before deployment.
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />

                                                    {/* Auto-Expire Options (only shown when capacity reservation is enabled) */}
                                                    {enableCapacityReservation && (
                                                        <Box mt={2} ml={4} p={2} style={{backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={capacityReservationAutoExpire}
                                                                        onChange={event => {
                                                                            const newValue = event.target.checked;
                                                                            setCapacityReservationAutoExpire(newValue);
                                                                            setForm(prevForm => ({
                                                                                ...prevForm,
                                                                                data: {
                                                                                    ...prevForm.data,
                                                                                    network: {
                                                                                        ...prevForm.data.network,
                                                                                        capacity_reservation_auto_expire: newValue
                                                                                    }
                                                                                }
                                                                            }));
                                                                        }}
                                                                        name="capacityReservationAutoExpire"
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={
                                                                    <Box>
                                                                        <Typography variant="body2" style={{fontWeight: 500}}>
                                                                            Auto-Expire (Safety Net)
                                                                        </Typography>
                                                                        <Typography variant="caption" color="textSecondary" style={{display: 'block', marginTop: '4px'}}>
                                                                            Prevent orphaned capacity charges if deployment fails.
                                                                        </Typography>
                                                                    </Box>
                                                                }
                                                            />

                                                            {/* Expire Hours TextField (only shown when auto-expire is enabled) */}
                                                            {capacityReservationAutoExpire && (
                                                                <Box mt={1} ml={4}>
                                                                    <TextField
                                                                        type="number"
                                                                        label="Expiration Hours"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={capacityReservationExpireHours}
                                                                        onChange={event => {
                                                                            const newValue = parseInt(event.target.value, 10) || 1;
                                                                            setCapacityReservationExpireHours(newValue);
                                                                            setForm(prevForm => ({
                                                                                ...prevForm,
                                                                                data: {
                                                                                    ...prevForm.data,
                                                                                    network: {
                                                                                        ...prevForm.data.network,
                                                                                        capacity_reservation_expire_hours: newValue
                                                                                    }
                                                                                }
                                                                            }));
                                                                        }}
                                                                        inputProps={{ min: 1, max: 24 }}
                                                                        style={{width: '200px'}}
                                                                        helperText="Hours (1-24)"
                                                                    />
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                )}

                                {/* Storage Settings */}
                                {advanced && (
                                    <Card style={cardStyle}>
                                        <CardHeader
                                            title={
                                                <Box display="flex" alignItems="center">
                                                    <Icon className="mr-8">storage</Icon>
                                                    <Typography style={sectionTitleStyle}>Storage Settings</Typography>
                                                </Box>
                                            }
                                            style={cardHeaderStyle}
                                        />
                                        <CardContent>
                                            <div className="flex flex-row my-16 w-full">
                                                <React.Fragment>
                                                    <TextFieldFormsy
                                                        className={clsx(
                                                            classes.input, 'w-1/2 mr-8'
                                                        )}
                                                        id="azure_server-volume_size"
                                                        name="volume_size"
                                                        label="Server Volume (GB)"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.server.volume_size}
                                                        onChange={e => setServerObj(e.target)}
                                                        fullWidth
                                                        placeholder={`Disk size of the Cluster Head Node (Min: ${providerVolsize.min}, Max: ${providerVolsize.max})`}
                                                        validations={{
                                                            mustbenumber: (formValues, fieldValue) => {
                                                                return validationInput(
                                                                    'clusterservervolume',
                                                                    formValues.instance_id,
                                                                    fieldValue,
                                                                    1,
                                                                    "azure",
                                                                    currentMarketStack
                                                                );
                                                            }
                                                        }}
                                                        validationErrors={{
                                                            mustbenumber: validationMess('clusterservervolume', form.instance_id, 1, "azure", currentMarketStack)
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className={clsx(classes.input, 'mr-8')}
                                                        id="azure_node-volume_size"
                                                        name="volume_size"
                                                        label="Node Volume (GB)"
                                                        type="text"
                                                        variant="outlined"
                                                        value={form.data.node.volume_size}
                                                        onChange={e => setNodeObj(e.target)}
                                                        fullWidth
                                                        placeholder={`Disk size of the Cluster Nodes (Min: ${providerVolsize.min}, Max: ${providerVolsize.max})`}
                                                        validations={{
                                                            mustbenumber: (formValues, fieldValue) => {
                                                                const minValue = currentMarketStack ? currentMarketStack.config.node_volume : 1;
                                                                return validationInput('clusternodevolume', formValues.instance_id, fieldValue, minValue, "azure", currentMarketStack);
                                                            }
                                                        }}
                                                        validationErrors={{
                                                            mustbenumber: validationMess('clusternodevolume', form.instance_id, currentMarketStack ? currentMarketStack.config.node_volume : 1, "azure", currentMarketStack)
                                                        }}
                                                    />
                                                </React.Fragment>
                                                <TextFieldFormsy
                                                    className={clsx(classes.input, 'mr-8')}
                                                    id="azure_idle_purge_s"
                                                    name="idle_purge_s"
                                                    label="Idle Purge Time (S)"
                                                    type="number"
                                                    variant="outlined"
                                                    value={form.data.node.idle_purge_s}
                                                    onChange={e => setNodeObj(e.target)}
                                                    fullWidth
                                                    inputProps={{
                                                        min: 0
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className={clsx(classes.input)}
                                                    id="azure_resource_group_id"
                                                    name="resource_group_id"
                                                    label="Resource Group Name"
                                                    type="text"
                                                    variant="outlined"
                                                    value={form.data.resource_group_id}
                                                    onChange={e => setDataObj(e.target)}
                                                    fullWidth
                                                    placeholder="mygroup"
                                                />

                                            </div>
                                        </CardContent>
                                    </Card>
                                )}

                                {/* Compute Nodes */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Box display="flex" alignItems="center">
                                                    <Icon className="mr-8">device_hub</Icon>
                                                    <Typography style={sectionTitleStyle}>Compute Nodes</Typography>
                                                    <Tooltip title="Regions, sizes and quotas vary by account." style={tooltipIconStyle}>
                                                        <Icon className="ml-8">help_outline</Icon>
                                                    </Tooltip>
                                                </Box>
                                                <Button
                                                    variant="contained" size="small" startIcon={<Icon>add</Icon>}
                                                    onClick={addComputeNode}
                                                    disabled={form.data.node.group.length >= 250}
                                                >
                                                    Add Node Group
                                                </Button>
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                        {nodeInstanceSizes &&
                                            form.data.node.group.map((val, i) => {
                                                return (
                                                    <Paper
                                                        key={`node-${i}`}
                                                        elevation={2}
                                                        style={{
                                                            padding: '16px',
                                                            marginBottom: '16px',
                                                            borderLeft: '4px solid #2196F3'
                                                        }}
                                                    >
                                                        {/* Node Group Header */}
                                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                            <Typography variant="h6" style={{ color: '#333', fontWeight: 'bold' }}>
                                                                Node Group {i + 1}
                                                            </Typography>
                                                            {/* replace FAB with IconButton */}
                                                            <IconButton
                                                                size="small"
                                                                color="default"
                                                                onClick={() => removeComputeNode(i)}
                                                                disabled={form.data.node.group.length <= 1}
                                                                disableRipple
                                                                style={{
                                                                    color: form.data.node.group.length <= 1 ? 'rgba(0, 0, 0, 0.26)' : '#9e9e9e',
                                                                    backgroundColor: 'transparent'
                                                                }}
                                                                aria-label="remove node group"
                                                            >
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </Box>

                                                        {/* Hidden input for group_node_prefix_label - not displayed */}
                                                        <input 
                                                            type="hidden" 
                                                            name={`group_node_prefix_label_${i}`}
                                                            value={val.group_node_prefix_label || `Node Group ${i + 1}`} 
                                                        />
                                                        
                                                        {/* Input Fields */}
                                                        <div style={inputGroupStyle}>
                                                            {imageMode === IMAGE_MODE.MULTI_IMAGE && (
                                                                <>
                                                                    <TextField
                                                                        ref={el => groupNodePrefixRefs.current[i] = el}
                                                                        label="Stack"
                                                                        value={groupNodeInputValues[i] || ''}
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            setGroupNodeInputValues(prevValues => ({
                                                                                ...prevValues,
                                                                                [i]: newValue
                                                                            }));
                                                                            setNodePrefix(i, newValue);
                                                                            validateNodePrefix(newValue, i);
                                                                        }}
                                                                        variant="outlined"
                                                                        required
                                                                        disabled={Boolean(currentMarketStack)}
                                                                        error={nodePrefixErrors[i] ? true : false}
                                                                        helperText={nodePrefixErrors[i]}
                                                                        style={{ flex: 1 }}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <IconButton
                                                                                        disabled={Boolean(currentMarketStack)}
                                                                                        onClick={() => handleGroupNodeMenuOpen(i)}>
                                                                                        <ArrowDropDownIcon />
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />

                                                                    <Menu
                                                                        anchorEl={groupNodePrefixRefs.current[activeMenuIndex]}
                                                                        open={activeMenuIndex === i}
                                                                        onClose={() => setActiveMenuIndex(null)}
                                                                    >
                                                                        {
                                                                            stacks
                                                                                .filter(stack => stack.info?.state === "success" && stack?.provider === "azure")
                                                                                .length > 0
                                                                                ? stacks
                                                                                    .filter(stack => stack.info?.state === "success" && stack?.provider === "azure")
                                                                                    .map((stack, index) => (
                                                                                        <MenuItem
                                                                                            key={index}
                                                                                            onClick={() => handleGroupNodeMenuItemClick(i, stack.data.prefix)}
                                                                                        >
                                                                                            {stack.data.prefix}
                                                                                        </MenuItem>
                                                                                    ))
                                                                                : <MenuItem disabled>No stack builds available for this provider</MenuItem>
                                                                        }
                                                                    </Menu>
                                                                </>
                                                            )}

                                                            <SelectFormsy
                                                                id={`node-size-${i}`}
                                                                name="node_instance_id"
                                                                label="Size *"
                                                                type="select"
                                                                variant="outlined"
                                                                value={val.instance_id}
                                                                onChange={e => setInstanceId(i, e.target.value)}
                                                                required
                                                                style={{ flex: 2 }}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: { maxHeight: 300 }
                                                                    }
                                                                }}
                                                            >
                                                                {nodeInstanceSizes
                                                                    .filter(s => !marketplaceComputeIds || marketplaceComputeIds.includes(s.instance_id))
                                                                    .map((s, i) => (
                                                                        <MenuItem id={s.name} key={i} value={s.instance_id} disabled={s.instance_id === 'BM.GPU4.8' && selectedShapes.includes(s.instance_id)}>
                                                                            {s.name}
                                                                        </MenuItem>
                                                                    ))}
                                                            </SelectFormsy>
                                                            
                                                            {imageMode === IMAGE_MODE.MULTI_IMAGE && (
                                                                <SelectFormsy
                                                                    id={`node-image-type-${i}`}
                                                                    name="node_image_type"
                                                                    label="Image Type"
                                                                    type="select"
                                                                    variant="outlined"
                                                                    value={nodeImageTypes[i] || IMAGE_TYPE.HEIDI_STACK}
                                                                    onChange={e => setNodeImageType(i, e.target.value)}
                                                                    style={{ width: '180px' }}
                                                                    disabled={Boolean(currentMarketStack)}
                                                                >
                                                                    <MenuItem value={IMAGE_TYPE.HEIDI_STACK}>Heidi Stack</MenuItem>
                                                                    <MenuItem value={IMAGE_TYPE.CUSTOM_STACK}>Custom Stack</MenuItem>
                                                                </SelectFormsy>
                                                            )}

                                                            <TextFieldFormsy
                                                                id={`count-${i}`}
                                                                name="count"
                                                                label="Count"
                                                                type="number"
                                                                variant="outlined"
                                                                value={val.count || "0"}
                                                                onChange={e => setInstanceCount(i, e.target, val.instance_id)}
                                                                required
                                                                style={{ width: '120px' }}
                                                                inputProps={{
                                                                    min: 0,
                                                                    max: 250
                                                                }}
                                                            />
                                                        </div>
                                                    </Paper>
                                                );
                                            })}
                                    </CardContent>
                                </Card>

                                {/* Description */}
                                <Card style={cardStyle}>
                                    <CardHeader
                                        title={
                                            <Box display="flex" alignItems="center">
                                                <Icon className="mr-8">description</Icon>
                                                <Typography style={sectionTitleStyle}>Description</Typography>
                                            </Box>
                                        }
                                        style={cardHeaderStyle}
                                    />
                                    <CardContent>
                                        <TextField
                                            className={clsx(classes.input, 'my-16 w-full')}
                                            id="azure_description"
                                            name="description"
                                            label="Description"
                                            type="textarea"
                                            variant="outlined"
                                            value={form.description}
                                            onChange={handleChange}
                                            fullWidth
                                            multiline
                                            minRows={3}
                                        />
                                    </CardContent>
                                </Card>

                            </Formsy>
                        </DisabledFormWrapper>
                    </DialogContent>

                    <ScriptDialog
                        open={isScriptOpen}
                        onClose={() => setScriptOpen(false)}
                        scriptContent={form?.data?.provision?.script || ''}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default AzureCluster;